import React from "react";
import styled from "styled-components";
import Img from 'gatsby-image';
import { siteColors } from "../constants/colors";
import breakpoints from "../constants/breakpoints";
import {
  Band,
  BandTextContainer,
  BandTextHeader,
  BandBodyText,
} from "./band";
import { AdaptiveHostedVideo } from "./hosted-video.js";
import { VideoContainer, VideoInnerContainer } from "./ephemeral-video-container.js";

const TextMarginTopAdjustmentContainer = styled.div`
   margin-top: -4.0em;

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
   margin-top: 0.0em;
  }
`;

const PoseFreelyBand = (props) => (
  <Band background={siteColors.darkest} reverse>
        <VideoContainer>
        <VideoInnerContainer>
        <AdaptiveHostedVideo url="https://www.youtube.com/embed/IpB3GEWj4Sc?si=tIgSXTEIbh8Az2VW" title="Ephemeral Posing" />
        </VideoInnerContainer>
        </VideoContainer>
    <BandTextContainer>
        <TextMarginTopAdjustmentContainer>
      <BandTextHeader>
        Pose freely
      </BandTextHeader>
      <BandBodyText>
        Traditional rigging makes animators manage rig state–like FK/IK and
    space switches–manually. We want to free animators to pose a character
    any way they want to, whenever they want to.
      </BandBodyText>

      <BandBodyText>
        So the Ephemeral Animation System offers “manipulation modes” (like
        Forward, Backward, or IK) instead of switches, blends, and alternate
    controls. No need to worry about whether you’re painting yourself into a
    corner by choosing FK over IK, or world over local space. There are no
    wrong choices!
      </BandBodyText>
        </TextMarginTopAdjustmentContainer>
    </BandTextContainer>
  </Band>
);

export default PoseFreelyBand;
